// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/payTemplate.css
// module id = 2013
// module chunks = 2